module.exports = __webpack_public_path__ + "static/img/tit.d1ebd151.png";